import React, { useContext, useEffect, useState } from 'react'
// import { FiSend } from "react-icons/fi";
import AsyncSelect from 'react-select/async';
import { Card, Form, Button, Row, Col, Badge, Container, Table } from 'react-bootstrap';
import _ from "lodash";
import Dialog from '../Dialog';
import * as Common from "../Common";
import * as Picklist from "../Picklist";
import $ from "jquery";
// import { OrderContext } from "../context";
import { useNavigate } from 'react-router-dom';
import VerifyMobileEmailOtp from '../verifyMobileEmailOtp';
import Menu from '../Menu';
import LoginHeader from '../Login_header';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatePicker from 'react-datepicker';
import Select from "react-select";


function TutionFeeForm() {
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [country3DISOCode, setCountry3DISOCode] = useState('');
    const [instituteList, setInstituteList] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const [selectedInstitute, setSelectedInstitute] = useState('');
    const [instituteId, setInstituteId] = useState('');
    const [instituteName, setInstituteName] = useState('');
    const [selectedServices, setSelectedServices] = useState([]);
    const [amount, setAmount] = useState('');
    const [myModal, setMyModal] = useState(false);
    const [modalText, setModalText] = useState('');
    const [modalData, setModalData] = useState({});

    // const { converaObj, setConveraObj } = useContext(OrderContext);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zipcode, setZipcode] = useState('');
    const [mobile, setMobile] = useState('');
    const [verifyOtpModal, setVerifyOtpModal] = useState(false);
    const [studentId, setStudentId] = useState('');
    const [srno, setSrno] = useState(0);
    const [executiveCode, setExecutiveCode] = useState(0);
    const [executive, setExecutive] = useState("");
    const [branch, setBranch] = useState();
    const [branchCode, setBranchCode] = useState(0);
    const [scrMode, setScrMode] = useState('');
    const [filLocation, setFilLocation] = useState();
    const [radioType, setRadioType] = useState("N");
    const [filFromSrno, setFilFromSrno] = useState("");
    const [filToSrno, setFilToSrno] = useState("");
    const [limit, setLimit] = useState(10);
    const [filMode, setFilMode] = useState("ALL");
    const [list, setList] = useState([]);
    const [userRight, setUserRight] = useState()
    const [viewDate, setViewDate] = useState(new Date())
    const [servList, setServList] = useState([])
    const [agent, setAgent] = useState(null)
    const [agentCode, setAgentCode] = useState(0)
    const [agentGroup, setAgentGroup] = useState(0)
    const [agentCommission, setAgentCommission] = useState(0)
    const [filterFromDate, setFilterFromDate] = useState(new Date());
    const [filterToDate, setFilterToDate] = useState(new Date());




    const branchDisable = sessionStorage.getItem('branchDisable');
    const sid = sessionStorage.getItem("sessionId");
    const navigate = useNavigate();
    useEffect(() => {
        if (sessionStorage.getItem("activeBranch") == Common.HoCode) {
            sessionStorage.activeBranch = sessionStorage.getItem('activeBranchWithoutHo');
        }
        Common.getActiveBranch().then(response => {
            setBranch(response);
            console.log(response)
            if (response != null) {
                setFilLocation(response);
                setBranchHandler(response);
            }
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_CONVERA'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });
        isLiveSetup();
    }, [])
    const isLiveSetup = () => {
        Common.callApi(Common.liveSetup, ["checkLiveSetup"], function (result) {
            try {
                const resp = JSON.parse(result);
                const isLive = resp;
                console.log(isLive)
                if (isLive == true) {
                    sessionStorage.setItem('isLive', 'true');
                } else {
                    sessionStorage.setItem('isLive', 'false');
                }
            } catch (e) {
                // console.error("Invalid JSON response from live setup:", result);
            }
        });
    };

    const submitForm = (e) => {
        $(".loader").show();
        e.preventDefault();
        let i = 0;
        let msg = [];
        msg[i++] = 'Please Fill Mandatory Field.'
        !executiveCode && (msg[i++] = 'Excecutive.');
        !branch && (msg[i++] = 'Branch.');
        !instituteId && (msg[i++] = 'Institute.');
        !country3DISOCode && (msg[i++] = 'Country');
        !firstName && (msg[i++] = 'First Name');
        !email && (msg[i++] = 'Email');
        !mobile && (msg[i++] = 'Mobile');


        if (i > 1) {
            $(".loader").hide();
            let dmsg = {};
            // dmsg.title = "Please Fill Mandatory Field.";
            dmsg = Common.buildMessageFromArray(msg);
            setMyModal(true);
            setModalText(dmsg);
        } else {
            const serviceSummary = {
                services: selectedServices,
                totalAmount: selectedServices.reduce((sum, s) => sum + parseFloat(s.amountOwing || 0), 0)
            };
            console.log("Selected Country:", selectedCountry);
            console.log("Selected Institute:", selectedInstitute);
            console.log("Selected Services:", serviceSummary);
            const obj = {
                clientId: instituteId,
                clientName: instituteName,
                country: country3DISOCode,
                services: selectedServices,
                firstName: firstName,
                lastName: lastName,
                address: address,
                city: city,
                state: state,
                zipcode: zipcode,
                email: email,
                mobile: mobile,
                amount: serviceSummary?.totalAmount || 0,
                studentId: studentId,
                executiveCode: executiveCode,
                branchCode: branchCode,
                agentCode: agentCode,
                agentGroup: agentGroup,
                agentCommission: agentCommission
            }
            Common.callApi(Common.apiConvera, ["save", JSON.stringify(obj)], function (result) {
                $(".loader").hide();
                const resp = JSON.parse(result || '[]');
                if (resp?.status) {
                    setSrno(resp?.data?.srno)
                    obj.refno = resp.data.refno;
                    sessionStorage.setItem('converaObj', JSON.stringify(obj));
                    setScrMode()
                    navigate("/convera");
                } else {
                    let msg = [];
                    msg[i++] = 'ERROR.'
                    msg[i++] = resp.msg;
                    setModalText(Common.buildMessageFromArray(msg));
                    setMyModal(true);
                }
            });
        }

    };

    const handleSelectedCountry = (value) => {
        $(".loader").show();
        setSelectedCountry(value);
        const id = value?.id?.split('^');
        const isdCode = id[4];
        setCountry3DISOCode(isdCode);
        const obj = { countryCode: isdCode };
        Common.callApi(Common.apiConvera, ["allInstitute", JSON.stringify(obj)], function (result) {
            $(".loader").hide();
            const resp = JSON.parse(result || '[]');
            setInstituteList(resp);
        });
    };

    const handleInstitute = (stringifiedObj) => {
        $(".loader").show();
        setSelectedInstitute(stringifiedObj);
        // const parseObj = JSON.parse(stringifiedObj);
        const val = stringifiedObj.value.split('^')
        setInstituteId(val[0]);
        setInstituteName(val[1]);
        const obj = { id: val[0] };
        Common.callApi(Common.apiConvera, ["allservice", JSON.stringify(obj)], function (result) {
            $(".loader").hide();
            const resp = JSON.parse(result || '[]');
            setServiceList(resp);
            setSelectedServices(resp); // clear previous selections
        });
    };

    const handleServiceToggle = (service, checked) => {
        if (checked) {
            setSelectedServices(prev => [...prev, service]);
        } else {
            setSelectedServices(prev => prev.filter(s => s.id !== service.id));
        }
    };
    const handleExecutive = (value) => {
        console.log(value);
        setExecutive(value);
        const exec = value.id.split('^');
        setExecutiveCode(exec[1]);
    }
    const handleAgentChange = (value) => {
        setAgent(value);
        const idArr = value.id.split('^');
        setAgentGroup(idArr[1])
        setAgentCode(idArr[2]);
    }
    const setBranchHandler = (value) => {
        setBranch(value);
        var id = value.id;
        var locationVal = id.split('^');
        setBranchCode(locationVal[1]);
    }
    const handleFilLocationChange = (value) => {
        setFilLocation(value);
        var locationVal = value.id.split('^');
        sessionStorage.activeBranch = locationVal[1];
    }
    const listHadndler = () => {
        $(".loader").show();
        let msg = [];
        let i = 0;
        msg[i++] = "Fill neccessary Details";
        !filLocation && (msg[i++] = "Location");
        let LocCode = filLocation.id.split('^')[1];
        if (radioType === 'S') {
            !filFromSrno && (msg[i++] = "From Srno")
            !filToSrno && (msg[i++] = "To Srno");
        }
        if (i > 1) {
            $(".loader").hide();
            setMyModal(true);
            setModalText(Common.buildMessageFromArray(msg));
        } else {
            const obj = {
                location: LocCode,
                radioType: radioType,
                fromSrno: filFromSrno,
                toSrno: filToSrno,
                mode: filMode,
                limit: limit,
                fromDate: Common.dateYMD(filterFromDate),
                toDate: Common.dateYMD(filterToDate)
            }
            Common.callApi(Common.apiConvera, ["list", JSON.stringify(obj)], function (result) {
                $(".loader").hide();
                const resp = JSON.parse(result || '[]');
                if (resp?.status) {
                    setList(resp.list);
                } else {
                    let msg = [];
                    msg[i++] = 'ERROR.'
                    msg[i++] = resp.msg;
                    setModalText(Common.buildMessageFromArray(msg));
                    setMyModal(true);
                }
            });
        }
    }
    const fillViewForm = (srno) => {
        // $(".loader").show();
        const obj = {
            srno: srno,
        }
        Common.callApi(Common.apiConvera, ["view", JSON.stringify(obj)], function (result) {
            // $(".loader").hide();
            const resp = JSON.parse(result || '[]');
            if (resp?.status) {
                setViewDate(resp.obj[0]);
                setServList(resp.serviceList);
                setScrMode('V')
            } else {
                let msg = [];
                let i = 0;
                msg[i++] = 'ERROR.'
                msg[i++] = resp.msg;
                setModalText(Common.buildMessageFromArray(msg));
                setMyModal(true);
            }
        });
    }
    const addNewForm = () => {
        setSrno(0)
        setScrMode('A');
        setFilFromSrno('');
        setFilMode('ALL');
        setFilToSrno('');
        setLimit(10);
    }
    const backBtnHandler = () => {
        setScrMode('');
    }

    const exportHadndler = () => {
        $(".loader").show();
        let msg = [];
        let i = 0;
        msg[i++] = "Fill neccessary Details";
        !filLocation && (msg[i++] = "Location");
        let LocCode = filLocation.id.split('^')[1];
        if (radioType === 'S') {
            !filFromSrno && (msg[i++] = "From Srno")
            !filToSrno && (msg[i++] = "To Srno");
        }
        if (i > 1) {
            $(".loader").hide();
            setMyModal(true);
            setModalText(Common.buildMessageFromArray(msg));
        } else {
            const obj = {
                location: LocCode,
                radioType: radioType,
                fromSrno: filFromSrno,
                toSrno: filToSrno,
                mode: filMode,
                limit: limit,
                fromDate: Common.dateYMD(filterFromDate),
                toDate: Common.dateYMD(filterToDate),
                right: "TRAN_CONVERA"
            }
            Common.callDownloadApiPost1(Common.apiReport, "post", [sid, JSON.stringify(obj)], result => {
                $(".loader").hide();
                setModalText(Common.buildMessageFromArray([result]));
                setMyModal(true);
            });
        }
    }

    // const badgeStyle ="{ backgroundColor:'#00C7B3 !important'}";
    return (<>
        <LoginHeader />
        <Menu />
        <Container fluid>
            <Row>
                <Col><h1>Convera Payments </h1></Col>
                <hr />
            </Row>
            {scrMode === '' && <>
                <Row>
                    <Col className='col-md-6 col-6'>
                        <Form.Group>
                            <Row>
                                <Col>
                                    <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />
                                </Col>
                                <Col>
                                    <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                </Col>
                                <Col>
                                    <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                </Col>
                            </Row>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                            <AsyncSelect
                                cacheOptions={false}
                                defaultOptions={false}
                                value={filLocation}
                                getOptionLabel={e => e.label + ' '}
                                getOptionValue={e => e.id}
                                loadOptions={Picklist.fetchLocationAllowedPicklist}
                                onInputChange={Picklist.handleInputChange}
                                onChange={handleFilLocationChange}
                                isDisabled={branchDisable === "true"}
                            >
                            </AsyncSelect>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode</Form.Label>
                            <Form.Select value={filMode} onChange={e => setFilMode(e.target.value)} required>
                                <option value="ALL">ALL</option>
                                <option value="ONLINE">ONLINE</option>
                                <option value="OFFLINE">OFFLINE</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Limit</Form.Label>
                            <Form.Select value={limit} onChange={e => setLimit(e.target.value)} required>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    {
                        radioType === "S" &&
                        <>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                    <Form.Control type='text' maxLength={5} value={filFromSrno} onChange={e => Common.validateNumValue(e.target.value, setFilFromSrno)} />
                                </Form.Group>
                            </Col>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                    <Form.Control type='text' maxLength={5} value={filToSrno} onChange={e => Common.validateNumValue(e.target.value, setFilToSrno)} />
                                </Form.Group>
                            </Col>
                        </>
                    }
                    {radioType === 'D' &&
                        <>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                    <DatePicker className="form-control"
                                        selected={filterFromDate}
                                        onChange={(date) => setFilterFromDate(date)}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        useShortMonthInDropdown
                                        dropdownMode="select"
                                        peekNextMonth
                                        customInput={
                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                    <DatePicker className="form-control"
                                        selected={filterToDate}
                                        onChange={(date) => setFilterToDate(date)}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        useShortMonthInDropdown
                                        dropdownMode="select"
                                        peekNextMonth
                                        customInput={
                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                        }
                                    />
                                </Form.Group>
                            </Col>
                        </>}
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        {
                            userRight?.query === "1" && (radioType !== "N") ?
                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => listHadndler()}>List</Button> : null
                        }
                        &nbsp;
                        {
                            userRight?.add === "1" && radioType === "N" ?
                                <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNewForm()}>Add New</Button> : null
                        }
                        {
                            userRight?.query === "1" && (radioType !== "N") ?
                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => exportHadndler()}>Export</Button> : null
                        }
                        &nbsp;
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Table responsive striped>
                        <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <th>Sr No</th>
                                <th>Date</th>
                                <th>Location</th>
                                <th>Name</th>
                                <th>Mobile No</th>
                                <th>Email</th>
                                <th>Student Id</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                list?.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <span onClick={() => fillViewForm(item.ch_srno)} className='pointer colorThemeBlue'>
                                                <FontAwesomeIcon icon={faEye} />
                                            </span>
                                        </td>
                                        <td>{item.ch_srno}</td>
                                        <td>{item.ch_date}</td>
                                        <td>{item.ch_location}</td>
                                        <td>{item.ch_name}</td>
                                        <td>{item.ch_mbile}</td>
                                        <td>{item.ch_email}</td>
                                        <td>{item.ch_student_id}</td>
                                        <td>{item.ch_status}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                </Row>
            </>}
            {scrMode === 'A' && <>
                <Container fluid>
                    <div className="container mt-5" >
                        <div className="shadow rounded-4 " style={{ padding: '0px' }}>
                            <div style={{
                                backgroundColor: 'rgb(18 129 243)', borderTopLeftRadius: '16px',
                                borderTopRightRadius: '16px', height: '3rem', color: 'white',
                                display: 'flex', flexDirection: 'row', alignItems: 'center',
                                justifyContent: 'center'
                            }} >
                                <h3 className=" text-center" >Convera Payment&nbsp;
                                </h3>
                                <Badge className="converaBadge" onClick={() => window.open(Common.converaPaymentTrackerURL, "_blank")}>Track Your Payment</Badge>
                            </div>
                            <div style={{
                                textAlign: 'left', padding: '2rem', backgroundColor: '#dedede',
                                borderBottomLeftRadius: '1rem',
                                borderBottomRightRadius: '1rem'
                            }} >
                                <Form >
                                    <Row>
                                        <Col className='col-md-6 col-6'>
                                            <Form.Group>
                                                <Form.Label><strong>Branch</strong></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={branch}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={Picklist.fetchLocationAllowedPicklist}
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={setBranchHandler}
                                                    isDisabled={branchDisable === "true"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-6 col-6'>
                                            <Form.Group>
                                                <Form.Label><strong>Executive</strong><span className="text-danger">*</span></Form.Label>
                                                <AsyncSelect
                                                    // disabled={scrMode === "Q"}
                                                    // isDisabled={scrMode === "Q"}
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={executive}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={Picklist.fetchExecutivePicklist}
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleExecutive}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>


                                    </Row>

                                    {/*First Name */}
                                    <Row>

                                        <Col className='col-md-6 col-6'>
                                            <Form.Group controlId="firstName">
                                                <Form.Label ><strong>First Name</strong></Form.Label>
                                                <Form.Control
                                                    type='text'
                                                    placeholder="First Name"
                                                    value={firstName}
                                                    onChange={(e) => setFirstName(e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        {/*Last Name */}
                                        <Col className='col-md-6 col-6'>
                                            <Form.Group controlId="lastName">
                                                <Form.Label ><strong>Last Name</strong></Form.Label>
                                                <Form.Control
                                                    type='text'
                                                    placeholder="Last Name"
                                                    value={lastName}
                                                    onChange={(e) => setLastName(e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {/* address */}
                                    <Form.Group controlId="address">
                                        <Form.Label ><strong>Address</strong></Form.Label>
                                        <Form.Control
                                            type='text'
                                            placeholder="Address"
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="city">
                                                <Form.Label ><strong>City</strong></Form.Label>
                                                <Form.Control
                                                    type='text'
                                                    placeholder="City"
                                                    value={city}
                                                    onChange={(e) => setCity(e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group controlId="address">
                                                <Form.Label ><strong>State</strong></Form.Label>
                                                <Form.Control
                                                    type='text'
                                                    placeholder="State"
                                                    value={state}
                                                    onChange={(e) => setState(e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {/* Name */}
                                    <Row>

                                        <Col>
                                            <Form.Group controlId="mobile">
                                                <Form.Label ><strong>Mobile</strong></Form.Label>
                                                <Form.Control
                                                    type='text'
                                                    placeholder="Mobile Number"
                                                    value={mobile}
                                                    onChange={(e) => setMobile(e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        {/* pincode  */}
                                        <Col>
                                            <Form.Group controlId="zipcode">
                                                <Form.Label ><strong>Zipcode</strong></Form.Label>
                                                <Form.Control
                                                    type='text'
                                                    placeholder="Zipcode"
                                                    value={zipcode}
                                                    onChange={(e) => setZipcode(e.target.value)}
                                                    length={6}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {/* email */}
                                    <Row>
                                        {/* <Col>
                                            <Form.Group controlId="studentId">
                                                <Form.Label ><strong>Student ID</strong></Form.Label>
                                                <Form.Control
                                                    type='text'
                                                    placeholder="Student ID"
                                                    value={studentId}
                                                    onChange={(e) => setStudentId(e.target.value)}
                                                    length={6}
                                                />
                                            </Form.Group>
                                        </Col> */}
                                        <Col>
                                            <Form.Group controlId="email">
                                                <Form.Label ><strong>Email</strong></Form.Label>
                                                <Form.Control
                                                    type='text'
                                                    placeholder="Email"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    {/* Country */}
                                    <Form.Group controlId="formCountry">
                                        <Form.Label ><strong>Country</strong></Form.Label>
                                        <Col style={{ borderRadius: '10px' }}>
                                            <AsyncSelect
                                                cacheOptions
                                                defaultOptions
                                                value={selectedCountry}
                                                getOptionLabel={e => e.label}
                                                getOptionValue={e => e.id}
                                                loadOptions={Picklist.fetchCountryPicklistBy3DigitISOCode}
                                                onInputChange={Picklist.handleInputChange}
                                                onChange={handleSelectedCountry}
                                            />
                                        </Col>
                                    </Form.Group>

                                    {/* Institution */}
                                    <Form.Group controlId="formInstitute">
                                        <Form.Label column sm={3}><strong>Institution</strong></Form.Label>
                                        {/* <Col >
                                            <Form.Select
                                                value={selectedInstitute}
                                                onChange={(e) => handleInstitute(e.target.value)}
                                            >
                                                <option value="">Select Institution</option>
                                                {instituteList.map(val => (
                                                    <option key={val.id} value={JSON.stringify(val)}>
                                                        {_.startCase(val.name)}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Col> */}
                                        <Select options={instituteList} value={selectedInstitute} onChange={v => handleInstitute(v)} />

                                    </Form.Group>
                                    <Row>
                                        <Col >
                                            {/* className='col-md-3 col-6' */}
                                            <Form.Group>
                                                <Form.Label><strong> Agent</strong></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={agent}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'AGENT', branchCode)}
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleAgentChange}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label><strong>Commission Flat</strong></Form.Label>
                                                <Form.Control value={agentCommission} onChange={e => Common.validateDecValue(e.target.value, setAgentCommission)} />
                                            </Form.Group>
                                        </Col>
                                        <Col></Col>
                                    </Row>

                                    {/* Services (Checkbox) */}
                                    {/* <Form.Group controlId="formService">
                                        <Form.Label ><strong>Services</strong></Form.Label>
                                        <Col >
                                            {serviceList.length > 0 ? (
                                                serviceList.map(service => {
                                                    const isChecked = selectedServices.some(s => s.id === service.id);
                                                    return (
                                                        <Form.Check
                                                            key={service.id}
                                                            type="checkbox"
                                                            label={`${_.startCase(service.name)} - ${service.amountOwing}`}
                                                            checked={isChecked}
                                                            onChange={(e) => handleServiceToggle(service, e.target.checked)}
                                                        />
                                                    );
                                                })
                                            ) : (
                                                <p className="text-muted">No services available</p>
                                            )}
                                        </Col>
                                    </Form.Group>
                                    <Form.Group className="mb-2" controlId="formAmount">
                                        <Form.Label ><strong>Total Amount</strong></Form.Label>
                                        <Col >
                                            <Form.Control
                                                type="text"
                                                placeholder="Amount will be calculated"
                                                value={selectedServices.reduce((sum, s) => sum + parseFloat(s.amountOwing || 0), 0)}
                                                disabled
                                            />
                                        </Col>
                                    </Form.Group> */}
                                    <Row> &nbsp;</Row>
                                    {/* Submit Button */}
                                    <Col className="d-flex justify-content-center">
                                        <Button variant="primary" type="submit"
                                            className="d-flex align-items-center gap-2 px-4"
                                            onClick={(e) => submitForm(e)}>
                                            Fill More Detail
                                            {/* <FiSend /> */}
                                        </Button>
                                        &nbsp;
                                        <Button variant="primary" type="submit"
                                            className="d-flex align-items-center gap-2 px-4"
                                            onClick={backBtnHandler}>
                                            Back
                                        </Button>
                                    </Col>
                                </Form>
                            </div>
                        </div>

                    </div>
                </Container>
            </>}
            {scrMode === 'V' && <>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => backBtnHandler()}>Back</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <strong>Srno : </strong>{viewDate.ch_srno}
                    </Col>
                    <Col>
                        <strong> Branch : </strong>{viewDate.ch_location_label}
                    </Col>
                    <Col>
                        <strong>Created Date: </strong>{viewDate.ch_date}
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <strong>Executive : </strong>{viewDate.ch_executive_label || ''}
                    </Col>
                    <Col>
                        <strong>Agent : </strong>{viewDate.ch_agent_label || ''}
                    </Col>
                    <Col>&nbsp;</Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <strong>Name : </strong>
                        {(viewDate.ch_first_name || '') + ' ' + (viewDate.ch_last_name || '')}
                    </Col>
                    <Col>
                        <strong>Mobile : </strong>{viewDate.ch_mbile || ''}
                    </Col>
                    <Col>
                        <strong>Email : </strong>{viewDate.ch_email || ''}
                    </Col>

                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <strong>Studenty ID : </strong>{viewDate.ch_student_id || ''}
                    </Col>

                    <Col>
                        <strong>City : </strong>{viewDate.ch_city || ''}
                    </Col>
                    <Col>&nbsp;</Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <strong>Addresss : </strong>{viewDate.ch_address || ''}
                    </Col>
                    <Col>
                        <strong>State : </strong>{viewDate.ch_city || ''}
                    </Col>
                    <Col>
                        <strong>Zipcode : </strong>{viewDate.ch_zipcode || ''}
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <strong>Client ID : </strong>{viewDate.ch_client_id || ''}
                    </Col>
                    <Col>
                        <strong>Client Name : </strong>{viewDate.ch_client_name || ''}
                    </Col>
                    <Col>
                        {/* Zipcode :{viewDate.ch_zipcode} */}
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <strong>Payment Status : </strong>{viewDate.ch_status ? (viewDate.ch_status + ' : ' + viewDate.cs_status_desc) : ''}
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <hr />
                {/* Services  */}
                {
                    /*

                                    <Row>
                                        <Table responsive striped>
                                            <thead>
                                                <tr>
                                                    <th>Line No</th>
                                                    <th>Srvice ID</th>
                                                    <th>Service Name</th>
                                                    <th>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    servList.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.csd_lineno || ''}</td>
                                                            <td>{item.csd_serviceid || ''}</td>
                                                            <td>{item.csd_service_name || ''}</td>
                                                            <td>{item.csd_amount || ''}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Row>
                    */
                }


            </>}
        </Container >
        <Dialog show={myModal} onHide={(e) => setMyModal(false)}>
            {modalText}
        </Dialog>
        {/* <VerifyMobileEmailOtp show={verifyOtpModal} srno={srno} onHide={() => setVerifyOtpModal(false)} /> */}
    </>
    );
}

export default TutionFeeForm;
